import React from 'react';
import { connect } from 'react-redux';
import { trans } from '../localization/language';
import { bindActionCreators } from 'redux';
import * as commonActions from '../actions/common';
import { timestampToString } from '../utils';

class LoginHistory extends React.Component {
	constructor() {
		super();
		this.state = {
			loadingLogs: false
		};
		this.handleScroll = this.handleScroll.bind(this);
	}

	renderTitle() {
		return (
			<div className="content-item__title" id="test-title">
				{trans('login_history')}
			</div>
		);
	}

	renderPanel() {
		return (
			<div className="oplog-panel">
				<div className="oplog-panel__txt">
					{trans('login_history_panel_text')}
				</div>
			</div>
		);
	}

	componentWillMount() {
		var now = Math.floor(Date.now()/1000);
		this.props.fetchMoreLogs(this.props.userInfo.uid, now, now);
	}

	renderTableHead() {
		return (
			<div className="oplog-table__thead">
				<div className="oplog-table__row">
					<div className="oplog-table__th oplog-table__date">{trans('date_time')}</div>
					<div className="oplog-table__th oplog-table__country">{trans('country')}</div>
					<div className="oplog-table__th oplog-table__ip">IP</div>
					<div className="oplog-table__th oplog-table__opsrc">{trans('source')}</div>
				</div>
			</div>
		);
	}

	renderTableRow(date, country, ip, source, index) {
		return (
			<div className="oplog-table__row oplog-table__tdrow" key={index}>
				<div className="oplog-table__td oplog-table__date">{date}</div>
				<div className="oplog-table__td oplog-table__country">{country}</div>
				<div className="oplog-table__td oplog-table__ip">{ip}</div>
				<div className="oplog-table__td oplog-table__opsrc">{source}</div>
			</div>
		);
	}

	renderTableBody() {
		var logs = [];
		this.props.loginLog.forEach(function(log, index){
			logs.push(this.renderTableRow(timestampToString(log.timestamp), log.country, log.ip, log.source, index));
		}, this);
		return (
			<div className="oplog-table__tbody">
				{logs}
			</div>
		);
	}

	renderLogTable() {
		return (
			<div className="oplog-table">
				{this.renderTableHead()}
				{this.renderTableBody()}
			</div>
		);
	}
	
	renderListRow(date, country, ip, source, index) {
		return (
			<div className="oplog-list__row" key={index}>
				<div className="oplog-list__row-info">
					<div className="oplog-list__row-l">{date}</div>
					<div className="oplog-list__row-r">{source}</div>
				</div>
				<div className="oplog-list__row-location">{ip} {country?'('+country+')':''}</div>
			</div>
		);
	}
	
	renderLogList() {
		var logs = [];
		this.props.loginLog.forEach(function(log,index){
			logs.push(this.renderListRow(timestampToString(log.timestamp), log.country, log.ip, log.source, index));
		}, this);
		return (
			<div className="oplog-list">
				{logs}
			</div>
		);
	}

	renderLogData() {
		return (
			<div className="oplog-data">
				{this.renderLogTable()}
				{this.renderLogList()}
			</div>
		);
	}

	renderMain() {
		return (
			<div className="oplog-wrap oplog-wrap--expanded">
				<div className="content-item__main">
					<div className="oplog">
						{this.renderPanel()}
						{this.renderLogData()}
					</div>
				</div>
			</div>
		);
	}

	startLoading() {
		if(!this.state.loadingLogs&&(this.props.last_login_ts>0||this.props.last_im_ts>0)){
			this.setState({loadingLogs:true});
			this.fetchLogs(this.props.last_login_ts, this.props.last_im_ts);
			this.setState({loadingLogs:false});
		}
	}

	handleScroll() {
		var needToLoad = elementInViewport(document.getElementById('loading'),200);
		if(needToLoad){
			this.startLoading();
		}
	}

	render() {
		window.addEventListener('scroll',this.handleScroll);
		return (
			<div className="main">
				<div className="content">
					<div className="content-item" onChange={()=>this.setState({loadingLogs:false})}>
						{this.renderTitle()}
						{this.renderMain()}
					</div>
					<div id="loading" style={{'textAlign':'center'}}> {this.state.loadingLogs?'Loading ...':''} </div>
				</div>

			</div>
		);
	}

	fetchLogs(last_login_ts, last_im_ts) {
		this.props.fetchMoreLogs(this.props.userInfo.uid, last_login_ts, last_im_ts);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		loginLog: state.data.loginLog,
		last_login_ts: state.data.last_login_ts,
		last_im_ts: state.data.last_im_ts,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, commonActions), dispatch);
}

function elementInViewport(el, toBottom) {
	if(el){
	  var top = el.offsetTop;
	  var left = el.offsetLeft;
	  var width = el.offsetWidth;
	  var height = el.offsetHeight;

	  while(el.offsetParent) {
		el = el.offsetParent;
		top += el.offsetTop;
		left += el.offsetLeft;
	  }

	  return (
		  (top - toBottom) < (window.pageYOffset + window.innerHeight) &&
		left < (window.pageXOffset + window.innerWidth) &&
		(top + height) > window.pageYOffset &&
		(left + width) > window.pageXOffset
	  );
	}else{
		return 0;
	}

}



export default connect(mapStateToProps, mapDispatchToProps)(LoginHistory);


// WEBPACK FOOTER //
// ./app/components/LoginHistory.js